export default "__VITE_ASSET__CXgJXTLL__"